const custom_report = {
    development: {
        estimate:{
            survey:{
                "アイダ設計":{ // アイダ設計 Y09_PDF
                    customer_natural_id: "CUS0000192S",
                    format: "Y09_PDF"
                },
                "イトーピアホーム":{ // イトーピアホーム　株式会社 Z01_AUTO
                    customer_natural_id: "CUS0000235R",
                    format: "Z01_AUTO"
                },
                "東建コーポレーション":{ // 東建コーポレーション Z02_AUTO
                    customer_natural_id: "CUS0000205H",
                    format: "Z02_AUTO"
                },
                "大成建設ハウジング":{ 
                    customer_natural_id: "CUS0000111B",
                    // 大成建設ハウジング 東海、九州、中部
                    customer_branch_natural_id: ["CUB0111012A","CUB10783513R","CUB0111006S"],
                    format: "Y15_PDF",
                    // 大成建設ハウジング 近畿
                    customer_branch_natural_id_2: ["CUB0111007T"],
                    format_2: "Y16_PDF",
                }
            },
            quote:{
                "三井ホーム":{
                    customer_natural_id : "CUS0000006G",// 三井ホーム　株式会社 -> その他 : customer_natural_id 6
                    "東北支店リフォーム営業室":{// 三井ホーム　株式会社 -> 東北支店リフォーム営業室 : customer_natural_id 6 customer_branch_natural_id 6024
                        customer_branch_natural_id:['CUB0006010E','CUB0006024U','CUB0006061M']
                    },
                    "埼玉支店":{// 三井ホーム　株式会社 -> 埼玉支店 : customer_natural_id 6 customer_branch_natural_id 6017
                        customer_branch_natural_id:[
                            'CUB0006017M','CUB0006018N','CUB0006025X','CUB0006026Y','CUB0006034G','CUB0006035H','CUB0006043R','CUB0006046U','CUB0006048Y'
                        ],
                    }
                },
                "住友不動産":{// 住友不動産　株式会社 : customer_natural_id 119
                    customer_natural_id: "CUS0000119K"
                },
                "共ショウ":{//株式会社　共ショウ
                    customer_natural_id  : "CUS0000796E",
                    format : "Y13_PDF",
                    document_name :{
                        mail:{
                            send_document_1:"納品書",
                            send_document_2:"契約駐車場の区画図面",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"確定見積書",
                            subcontract_send_document_2:"契約駐車場の区画図面",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                        fax:{
                            send_document_1:"区画図面",
                            send_document_2:"納品書",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"区画図面",
                            subcontract_send_document_2:"確定見積書",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                        sms:{
                            send_document_1:"区画図面",
                            send_document_2:"納品書",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"区画図面",
                            subcontract_send_document_2:"確定見積",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                    }
                }
            },
        },
        invoice:[
            {// H07_PDF_独自請求書（三井ホーム：その他） | STG,PRD共通　会社ID:6　上記以外
                customer_natural_id : "CUS0000006G",
                array_count : 20,
                format : "H07_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006017M",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006018N",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006025X",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006026Y",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006034G",
                array_count : 20,
                format : "H06_PDF"
            },        
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006035H",
                array_count : 20,
                format : "H06_PDF"
            },         
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006043R",
                array_count : 20,
                format : "H06_PDF"
            },           
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006046U",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006048Y",
                array_count : 20,
                format : "H06_PDF"
            },    
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006010E",
                array_count : 1,
                format : "H05_PDF"
            },
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006024U",
                array_count : 1,
                format : "H05_PDF"
            },
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006061M",
                array_count : 1,
                format : "H05_PDF"
            },
            {// Y10_PDF_独自請求書（住友不動産B表） | STG、PRD共通　会社ID:119 CUS0000119
                customer_natural_id: "CUS0000119K",
                array_count : 4,
                format : "Y10_PDF"
            },
            {// H08_PDF_独自請求書（独自請求書（大成建設ハウジング　東海））| "会社ID：CUS0000111B　支店ID：CUB0111012A"
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111012A",
                array_count : 11,
                format : "H08_PDF"
            },
            {// H08_PDF_独自請求書（独自請求書（大成建設ハウジング　九州））| "会社ID：CUS0000111B　支店ID：CUB10783513R"
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB10783513R",
                array_count : 11,
                format : "H08_PDF"
            },

        ],
        inhouse1_pdf:[
            {// Y10_PDF_独自請求書（住友不動産B表） | STG、PRD共通　会社ID:119 CUS0000119
                customer_natural_id: "CUS0000119K",
                array_count : 11,
                format : "Y11_PDF"
            }
        ],
        invoice_list:[
            {//H03_PDF_独自請求書（飯田産業）
                customer_natural_id : "CUS0000002C",
                array_count : 60,
                format : "H03_PDF"
            },
            {//G06_PDF_一覧請求書_オープンハウス・ディベロップメント用
                customer_natural_id : "CUS0000007H",
                format : "Z03_AUTO",
                only_customer_branch_auto_flag : true // 支店自動登録だけ使う
            },
        ],
        contract:[
            {//Y02_PDF_独自契約書（飯田産業）
                customer_natural_id : "CUS0000002C",
                format : "Y02_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {// Y03_PDF_独自契約書（タクトホーム）
                customer_natural_id : "CUS0000058Q",
                format : "Y03_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {// Y04_PDF_独自契約書（アーネストワン）
                customer_natural_id : "CUS0000050G",
                format : "Y04_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y05_PDF_独自契約書（三栄建築設計）
                customer_natural_id : "CUS0000004E",
                format : "Y05_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y06_PDF_独自契約書（ナイス）
                customer_natural_id : "CUS0000091D",
                format : "Y06_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y07_PDF_独自契約書（大東建託）
                customer_natural_id : "CUS0000003D",
                format : "Y07_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: true //口座必須チェックフラグ
            },
            {//Y08_PDF_独自契約書_駐車場申請書（一条工務店）
                customer_natural_id : "CUS0000083T",
                format : "Y08_PDF",
                cufile_option: true, //顧客システム独自資料対応
                bank_required_checkflg: true //口座必須チェックフラグ
            },
            {//Y14_PDF_独自契約書（東栄住宅）| STG、PRD共通　会社ID:14
                customer_natural_id : "CUS0000014Q",
                format : "Y14_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y17_PDF_独自契約書（大成建設ハウジング　関東用）
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111004Q",
                format : "Y17_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y17_PDF_独自契約書（大成建設ハウジング　関東用）
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111013B",
                format : "Y17_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
        ],
    },
    staging: {
        estimate:{
            survey:{
                "アイダ設計":{  // アイダ設計 Y09_PDF | PRD 会社ID:192 CUS0000192S
                    customer_natural_id: "CUS0000192S",
                    format: "Y09_PDF"
                },
                "イトーピアホーム":{ // イトーピアホーム　株式会社 CUS0000235R Z01_AUTO
                    customer_natural_id: "CUS0000235R",
                    format: "Z01_AUTO"
                },
                "東建コーポレーション":{ // 東建コーポレーション CUS0000205H Z02_AUTO
                    customer_natural_id: "CUS0000205H",
                    format: "Z02_AUTO"
                },
                "大成建設ハウジング":{ 
                    // 大成建設ハウジング 東海、九州、中部
                    customer_natural_id: "CUS0000111B",
                    customer_branch_natural_id: ["CUB0111012A","CUB10783513R","CUB0111006S"],
                    format: "Y15_PDF",
                    // 大成建設ハウジング 近畿
                    customer_branch_natural_id_2: ["CUB0111007T"],
                    format_2: "Y16_PDF",
                }
            },
            quote:{
                "三井ホーム":{
                    customer_natural_id : "CUS0000006G",// 三井ホーム　株式会社 -> その他 : customer_natural_id 6
                    "東北支店リフォーム営業室":{// 三井ホーム　株式会社 -> 東北支店リフォーム営業室 : "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                        customer_branch_natural_id:['CUB0006010E','CUB0006024U','CUB0006061M']
                    },
                    "埼玉支店":{// 三井ホーム　株式会社 -> 埼玉支店 : "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                        customer_branch_natural_id:[
                            'CUB0006017M','CUB0006018N','CUB0006025X','CUB0006026Y','CUB0006034G','CUB0006035H','CUB0006043R','CUB0006046U','CUB0006048Y'
                        ],
                    }
                },
                "住友不動産":{// 住友不動産　株式会社 : customer_natural_id 119
                    customer_natural_id: "CUS0000119K"
                },
                "共ショウ":{//株式会社　共ショウ
                    customer_natural_id  : "CUS0000796E",
                    format : "Y13_PDF",
                    document_name :{
                        mail:{
                            send_document_1:"納品書",
                            send_document_2:"契約駐車場の区画図面",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"確定見積書",
                            subcontract_send_document_2:"契約駐車場の区画図面",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                        fax:{
                            send_document_1:"区画図面",
                            send_document_2:"納品書",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"区画図面",
                            subcontract_send_document_2:"確定見積書",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                        sms:{
                            send_document_1:"区画図面",
                            send_document_2:"納品書",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"区画図面",
                            subcontract_send_document_2:"確定見積",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                    }
                }
            },
        },
        invoice:[
            {// H07_PDF_独自請求書（三井ホーム：その他） | STG,PRD共通　会社ID:6　上記以外
                customer_natural_id : "CUS0000006G",
                array_count : 20,
                format : "H07_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006017M",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006018N",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006025X",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006026Y",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006034G",
                array_count : 20,
                format : "H06_PDF"
            },        
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006035H",
                array_count : 20,
                format : "H06_PDF"
            },         
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006043R",
                array_count : 20,
                format : "H06_PDF"
            },           
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006046U",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006048Y",
                array_count : 20,
                format : "H06_PDF"
            },    
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006010E",
                array_count : 1,
                format : "H05_PDF"
            },
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006024U",
                array_count : 1,
                format : "H05_PDF"
            },
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006061M",
                array_count : 1,
                format : "H05_PDF"
            },
            {// Y10_PDF_独自請求書（住友不動産B表） | STG、PRD共通　会社ID:119 CUS0000119
                customer_natural_id: "CUS0000119K",
                array_count : 4,
                format : "Y10_PDF"
            },
            {// H08_PDF_独自請求書（独自請求書（大成建設ハウジング　東海））| "会社ID：CUS0000111B　支店ID：CUB0111012A"
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111012A",
                array_count : 11,
                format : "H08_PDF"
            },
            {// H08_PDF_独自請求書（独自請求書（大成建設ハウジング　九州））| "会社ID：CUS0000111B　支店ID：CUB10783513R"
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB10783513R",
                array_count : 11,
                format : "H08_PDF"
            },
            
        ],
        inhouse1_pdf:[
            {// Y10_PDF_独自請求書（住友不動産B表） | STG、PRD共通　会社ID:119 CUS0000119
                customer_natural_id: "CUS0000119K",
                array_count : 11,
                format : "Y11_PDF"
            }
        ],
        invoice_list:[
            {//H03_PDF_独自請求書（飯田産業） | STG、PRD共通　会社ID:2 CUS0000002
                customer_natural_id : "CUS0000002C",
                array_count : 60,
                format : "H03_PDF"
            },
            {//G06_PDF_一覧請求書_オープンハウス・ディベロップメント用
                customer_natural_id : "CUS0000007H",
                format : "Z03_AUTO",
                only_customer_branch_auto_flag : true // 支店自動登録だけ使う
            },
        ],
        contract:[
            {//Y02_PDF_独自契約書（飯田産業）| STG、PRD共通　会社ID:2 CUS0000002
                customer_natural_id : "CUS0000002C",
                format : "Y02_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {// Y03_PDF_独自契約書（タクトホーム）| STG、PRD共通　会社ID:58 CUS0000058
                customer_natural_id : "CUS0000058Q",
                format : "Y03_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {// Y04_PDF_独自契約書（アーネストワン）| STG、PRD共通　会社ID:50 CUS0000050
                customer_natural_id : "CUS0000050G",
                format : "Y04_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y05_PDF_独自契約書（三栄建築設計）| STG、PRD共通　会社ID:4
                customer_natural_id : "CUS0000004E",
                format : "Y05_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y06_PDF_独自契約書（ナイス）| "STG会社ID:91 PRD会社ID:91、313" CUS0000091
    
                customer_natural_id : "CUS0000091D",
                format : "Y06_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            // {//Y06_PDF_独自契約書（ナイス）| "STG会社ID:91 PRD会社ID:91、313" CUS0000313
            //     customer_natural_id : "CUS0000313F",
            //     format : "Y06_PDF"
            // },        
            {//Y07_PDF_独自契約書（大東建託）| STG、PRD共通　会社ID:3
                customer_natural_id : "CUS0000003D",
                format : "Y07_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: true //口座必須チェックフラグ
            },
            {//Y08_PDF_独自契約書_駐車場申請書（一条工務店）| STG、PRD共通　会社ID:83
                customer_natural_id : "CUS0000083T",
                format : "Y08_PDF",
                cufile_option: true, //顧客システム独自資料対応
                bank_required_checkflg: true //口座必須チェックフラグ
            },
            {//Y14_PDF_独自契約書（東栄住宅）| STG、PRD共通　会社ID:14
                customer_natural_id : "CUS0000014Q",
                format : "Y14_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y17_PDF_独自契約書（大成建設ハウジング　関東用）
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111004Q",
                format : "Y17_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y17_PDF_独自契約書（大成建設ハウジング　関東用）
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111013B",
                format : "Y17_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
        ],
    },
    production: {
        estimate:{
            survey:{
                "アイダ設計":{  // アイダ設計 Y09_PDF | PRD 会社ID:192 CUS0000192S
                    customer_natural_id: "CUS0000192S",
                    format: "Y09_PDF"
                },
                "イトーピアホーム":{ // イトーピアホーム　株式会社 CUS0000235R Z01_AUTO
                    customer_natural_id: "CUS0000235R",
                    format: "Z01_AUTO"
                },
                "東建コーポレーション":{ // 東建コーポレーション CUS0000205H Z02_AUTO
                    customer_natural_id: "CUS0000205H",
                    format: "Z02_AUTO"
                },
                "大成建設ハウジング":{ 
                    // 大成建設ハウジング 東海、九州、中部
                    customer_natural_id: "CUS0000111B",
                    customer_branch_natural_id: ["CUB0111012A","CUB10783513R","CUB0111006S"],
                    format: "Y15_PDF",
                    // 大成建設ハウジング 近畿
                    customer_branch_natural_id_2: ["CUB0111007T"],
                    format_2: "Y16_PDF",
                    
                }
            },
            quote:{
                "三井ホーム":{
                    customer_natural_id : "CUS0000006G",// 三井ホーム　株式会社 -> その他 : customer_natural_id 6
                    "東北支店リフォーム営業室":{// 三井ホーム　株式会社 -> 東北支店リフォーム営業室 : "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                        customer_branch_natural_id:['CUB0006010E','CUB0006024U','CUB0006061M']
                    },
                    "埼玉支店":{// 三井ホーム　株式会社 -> 埼玉支店 : "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                        customer_branch_natural_id:[
                            'CUB0006017M','CUB0006018N','CUB0006025X','CUB0006026Y','CUB0006034G','CUB0006035H','CUB0006043R','CUB0006046U','CUB0006048Y'
                        ],
                    }
                },
                "住友不動産":{// 住友不動産　株式会社 : customer_natural_id 119
                    customer_natural_id: "CUS0000119K"
                },
                "共ショウ":{//株式会社　共ショウ
                    customer_natural_id  : "CUS0000796E",
                    format : "Y13_PDF",
                    document_name :{
                        mail:{
                            send_document_1:"納品書",
                            send_document_2:"契約駐車場の区画図面",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"確定見積書",
                            subcontract_send_document_2:"契約駐車場の区画図面",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                        fax:{
                            send_document_1:"区画図面",
                            send_document_2:"納品書",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"区画図面",
                            subcontract_send_document_2:"確定見積書",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                        sms:{
                            send_document_1:"区画図面",
                            send_document_2:"納品書",
                            send_document_3:"駐車場賃貸借契約書",
                            subcontract_send_document_1:"区画図面",
                            subcontract_send_document_2:"確定見積",
                            subcontract_send_document_3:"駐車場賃貸借契約書",
                        },
                    }                       
                }                
            },
        },
        invoice:[
            {// H07_PDF_独自請求書（三井ホーム：その他） | STG,PRD共通　会社ID:6　上記以外
                customer_natural_id : "CUS0000006G",
                array_count : 20,
                format : "H07_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006017M",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006018N",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006025X",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006026Y",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006034G",
                array_count : 20,
                format : "H06_PDF"
            },        
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006035H",
                array_count : 20,
                format : "H06_PDF"
            },         
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006043R",
                array_count : 20,
                format : "H06_PDF"
            },           
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006046U",
                array_count : 20,
                format : "H06_PDF"
            },
            {//H06_PDF_独自請求書（三井ホーム：埼玉） | "STG会社ID:6、支店ID:6017 PRD会社ID:6、支店ID:10006017,10006018,10006025,10006026,10006034,10006035,10006043,10006046,10006048"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006048Y",
                array_count : 20,
                format : "H06_PDF"
            },    
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006010E",
                array_count : 1,
                format : "H05_PDF"
            },
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006024U",
                array_count : 1,
                format : "H05_PDF"
            },
            {// H05_PDF_独自請求書（三井ホーム：東北リフォーム）| "STG会社ID:6、支店ID:6024  PRD会社ID:6、支店ID:10006010、10006024、10006061"
                customer_natural_id : "CUS0000006G",
                customer_branch_natural_id:"CUB0006061M",
                array_count : 1,
                format : "H05_PDF"
            },
            {// Y10_PDF_独自請求書（住友不動産B表） | STG、PRD共通　会社ID:119 CUS0000119
                customer_natural_id: "CUS0000119K",
                array_count : 4,
                format : "Y10_PDF"
            },
            {// H08_PDF_独自請求書（独自請求書（大成建設ハウジング　東海））| "会社ID：CUS0000111B　支店ID：CUB0111012A"
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111012A",
                array_count : 11,
                format : "H08_PDF"
            },
            {// H08_PDF_独自請求書（独自請求書（大成建設ハウジング　九州））| "会社ID：CUS0000111B　支店ID：CUB10783513R"
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB10783513R",
                array_count : 11,
                format : "H08_PDF"
            },
        ],
        inhouse1_pdf:[
            {// Y10_PDF_独自請求書（住友不動産B表） | STG、PRD共通　会社ID:119 CUS0000119
                customer_natural_id: "CUS0000119K",
                array_count : 11,
                format : "Y11_PDF"
            }
        ],
        invoice_list:[
            {//H03_PDF_独自請求書（飯田産業） | STG、PRD共通　会社ID:2 CUS0000002
                customer_natural_id : "CUS0000002C",
                array_count : 60,
                format : "H03_PDF"
            },
            {//G06_PDF_一覧請求書_オープンハウス・ディベロップメント用
                customer_natural_id : "CUS0000007H",
                format : "Z03_AUTO",
                only_customer_branch_auto_flag : true // 支店自動登録だけ使う
            },
        ],
        contract:[
            {//Y02_PDF_独自契約書（飯田産業）| STG、PRD共通　会社ID:2 CUS0000002
                customer_natural_id : "CUS0000002C",
                format : "Y02_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {// Y03_PDF_独自契約書（タクトホーム）| STG、PRD共通　会社ID:58 CUS0000058
                customer_natural_id : "CUS0000058Q",
                format : "Y03_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {// Y04_PDF_独自契約書（アーネストワン）| STG、PRD共通　会社ID:50 CUS0000050
                customer_natural_id : "CUS0000050G",
                format : "Y04_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y05_PDF_独自契約書（三栄建築設計）| STG、PRD共通　会社ID:4
                customer_natural_id : "CUS0000004E",
                format : "Y05_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y06_PDF_独自契約書（ナイス）| "STG会社ID:91 PRD会社ID:91、313" CUS0000091
    
                customer_natural_id : "CUS0000091D",
                format : "Y06_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            // {//Y06_PDF_独自契約書（ナイス）| "STG会社ID:91 PRD会社ID:91、313" CUS0000313
            //     customer_natural_id : "CUS0000313F",
            //     format : "Y06_PDF"
            // },        
            {//Y07_PDF_独自契約書（大東建託）| STG、PRD共通　会社ID:3
                customer_natural_id : "CUS0000003D",
                format : "Y07_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: true //口座必須チェックフラグ
            },
            {//Y08_PDF_独自契約書_駐車場申請書（一条工務店）| STG、PRD共通　会社ID:83
                customer_natural_id : "CUS0000083T",
                format : "Y08_PDF",
                cufile_option: true, //顧客システム独自資料対応
                bank_required_checkflg: true //口座必須チェックフラグ
            },
            {//Y14_PDF_独自契約書（東栄住宅）| STG、PRD共通　会社ID:14
                customer_natural_id : "CUS0000014Q",
                format : "Y14_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y17_PDF_独自契約書（大成建設ハウジング　関東用）
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111004Q",
                format : "Y17_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
            {//Y17_PDF_独自契約書（大成建設ハウジング　関東用）
                customer_natural_id : "CUS0000111B",
                customer_branch_natural_id:"CUB0111013B",
                format : "Y17_PDF",
                cufile_option: false, //顧客システム独自資料対応
                bank_required_checkflg: false //口座必須チェックフラグ
            },
        ],
    }    
}
// console.log(process.env.REACT_APP_MODE)
// env values : production, staging, development
export default custom_report[process.env.REACT_APP_MODE]